import script from "./render.vue?vue&type=script&lang=ts"
export * from "./render.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__